module.exports = __webpack_public_path__ + "static/media/phonicle-bg.d531022b.jpg";